import { createSlice } from '@reduxjs/toolkit';

import { ActiveTournamentPlan, Plan } from '../domain/interfaces/plan';
import { createFetchActiveTournamentPlanReducer, createGivePlanReducer, createTopupBalanceReducer } from './reducers';

/**
 * Слайс держит только тарифные планы организаций. И список организаций,
 * и карточка одной читаются через RTK Query — `store/organizers-api.ts`.
 */
export type OrganizersSliceState = {
  plans: {
    list: Plan[];
    byOwnerId: Record<number, ActiveTournamentPlan | null>;
  };

  isProcessing: boolean;
  isProcessed: boolean;
  processName?: string;
};

const initialState: OrganizersSliceState = {
  plans: {
    byOwnerId: {},
    list: [
      {
        id: 0,
        name: 'Бесплатный',
        price: 0,
      },
      {
        id: -1,
        name: 'Базовый',
        price: 1500,
      },
      {
        id: -2,
        name: 'Продвинутый',
        price: 2500,
      },
      {
        id: 2,
        name: 'Профессиональный',
        price: 10000,
      },
    ],
  },

  isProcessing: false,
  isProcessed: false,
};

const slice = createSlice({
  name: 'organizers',
  initialState,
  extraReducers: (builder) => {
    createFetchActiveTournamentPlanReducer(builder);
    createTopupBalanceReducer(builder);
    createGivePlanReducer(builder);
  },
  reducers: {},
});

const organizersReducer = slice.reducer;
export default organizersReducer;
